import {Stack, Typography} from "@mui/material";
import {appStyles} from "../../../../AppStyles.ts";

function UXResourceNgramsPanel() {
    return (
        <Stack sx={appStyles.defaultPanelContainer} direction="column" padding={1} width="100%">
            <Stack direction="row" spacing={1} padding={1} alignItems="center">
                <Typography sx={appStyles.mainResourceTitle}>nGrams</Typography>
            </Stack>
        </Stack>
    );
}

export default UXResourceNgramsPanel;
